import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		padding: "0px 6px 6px 6px",
		margin: "20px 20px 0px 20px",
	},
}));

const MainHeader = ({ children, className = "" }) => {
	const classes = useStyles();

	return <div className={`${classes.contactsHeader} ${className}`}>{children}</div>;
};

export default MainHeader;

